import { render } from "./AddDefinitionExternalLinks.vue?vue&type=template&id=1a682c8a&ts=true"
import script from "./AddDefinitionExternalLinks.vue?vue&type=script&lang=ts"
export * from "./AddDefinitionExternalLinks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__